import { render, staticRenderFns } from "./DefaultHome.vue?vue&type=template&id=72a6996e&scoped=true&"
import script from "./DefaultHome.vue?vue&type=script&lang=js&"
export * from "./DefaultHome.vue?vue&type=script&lang=js&"
import style0 from "./DefaultHome.vue?vue&type=style&index=0&id=72a6996e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a6996e",
  null
  
)

export default component.exports